import * as React from 'react';
import classNames from 'classnames';
import { Menu as BlueprintMenu } from '@blueprintjs/core';

import './styles.scss';
import { compose } from 'redux';
import withStyles, { WithStyles } from 'react-jss';

export interface IMenuProps {
    /** Layout to use */
    layout?: 'default' | 'inline';
    /** className to append */
    className?: string;
}

interface IState {
}

type Props = IMenuProps & WithStyles<typeof styles>;

/**
 * Extends blueprint Menu component for style imports.
 */
class Menu extends React.Component<Props, IState> {
    static displayName: string = 'Menu';

    render () {
        return (
            <BlueprintMenu
                className={classNames('menu', {
                    'menu-layout-default': this.props.layout === 'default' || !this.props.layout,
                    'menu-layout-inline': this.props.layout === 'inline',
                }, this.props.classes.menu, this.props.className)}
            >
                {this.props.children}
            </BlueprintMenu>
        );
    }
}

const styles = (theme) => {
    return {
        menu: {
            '&.menu-layout-inline': {
                '& .menu-item': {
                    'color': theme.colors.text.dark,
                    'backgroundColor': theme.colors.gray.lighter,
                    '&.active': {
                        boxShadow: 'inset 0 0 0 3px ' + theme.colors.primary,
                    },
                    '&:hover': {
                        color: theme.colors.link,
                    },
                },
            },
        },
    };
};

export default compose<React.ComponentClass<IMenuProps>>(
    withStyles(styles, { injectTheme: true })
)(Menu);
